import React, { useEffect } from 'react';
import lib from '../../helpers/lib';

import TablePagination from '../../components/table-pagination';
import Layout from '../../components/layout/base/index';
import Select from 'react-select';
import SelectMulti from '../../components/_base/multi-select';
import NumberFormat from 'react-number-format';
import DatePickerCustom from '../../components/_base/DatePicker';
import ModalResumoPedido from '../../components/modal-resumo-pedido';
import ModalCancelarPedido from '../../components/modal-cancelar-pedido';
import ModalConfirmacao from '../../components/modal-confirmacao';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faEye, faXmark, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import PageTitleCard from 'components/page-title-card';
import PedidoService from 'services/pedido-service';
import RepresentadaService from 'services/representada-service';
import PedidoStatusService from 'services/pedido-status-service';
import RedeService from 'services/rede-service';
import PedidoFaturamentoService from 'services/pedido-faturamento-service';

import './styles.scss';

export default function DescarteNaoFaturados() {
  // const { data: pageData } = useQuery(['pedidos', filter], () => getPedidos(filter));

  const mesInicialFiltro = new Date(),
    y = mesInicialFiltro.getFullYear(),
    m = mesInicialFiltro.getMonth();

  const [filter, setFilter] = React.useState({
    dataInicio: new Date(y, m, 1),
    dataFim: null,
    representadaId: null,
    redeId: null,
    codigo: null,
    vendedorId: null,
    lojaCnpj: null,
    pedidoTipos: [],
    produtos: [],
    produtosIds: [],
    status: ['P', 'N'],
    pageNumber: 1,
    pageSize: 25
  });

  const [vendedores, setVendedores] = React.useState([]);
  const [pedidoTipos, setPedidoTipos] = React.useState([]);
  const [representadas, setRepresentadas] = React.useState([]);
  const [produtos, setProdutos] = React.useState([]);
  const [redes, setRedes] = React.useState([]);
  const [statusSelectList, setStatusSelectList] = React.useState([]);

  const [tiposSelecionados, setTiposSelecionados] = React.useState([]);
  const [produtosRepresentada, setProdutosRepresentada] = React.useState([]);
  const [pedidosStatus, setPedidosStatus] = React.useState([]);
  const [pedidos, setPedidos] = React.useState([]);

  // const [model, setModel] = React.useState({});
  const [showModalResumo, setShowModalResumo] = React.useState();
  const [showModalDescartar, setShowModalDescartar] = React.useState();
  const [showModalCancelar, setShowModalCancelar] = React.useState();
  const [selected, setSelected] = React.useState(null);
  const [selectedDescartar, setSelectedDescartar] = React.useState(null);

  useEffect(() => {
    (async () => {
      window.showLoader();

      await dataFimDefault();
      await getPedidoTipos();
      await getSelectListRepresentada();
      // await getSelectListStatus();
      await getSelectListRede();
      await getSelectListVendedor();

      window.hideLoader();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!showModalCancelar) {
        await getPedidosNaoFaturados();
      }
    })();
  }, [showModalCancelar]);

  async function dataFimDefault() {
    let dataFim = new Date();

    dataFim.setMonth(dataFim.getMonth() + 1);
    dataFim.setHours(0, 0, 0, 0);
    dataFim.setDate(0);

    setFilter({
      ...filter,
      dataFim: dataFim
    });
  }

  const getPedidoTipos = async () => {
    const response = await PedidoService.GetPedidoTiposAsync();

    if (response?.data?.data.length > 0) {
      setPedidoTipos(response?.data?.data);
    }
  };

  async function getSelectListRepresentada() {
    let response = await RepresentadaService.selectListAsync();

    if (response.data) {
      setRepresentadas(response.data.data);
    }

    if (response.data.data[0]?.options?.length === 1) {
      const representada = response.data.data[0].options[0];

      setFilter({
        ...filter,
        representadaId: representada.value
      });
      // getSelectListProdutos(representada.value);
    }
  }

  async function getSelectListStatus() {
    let resultStatus = await PedidoStatusService.getSelectListSiglaAsync();

    if (resultStatus?.data?.data[0]?.options) {
      setStatusSelectList(resultStatus.data.data[0].options);
    }
  }

  async function getSelectListRede() {
    let redes = await RedeService.getSelectList();

    if (redes.data) {
      setRedes(redes.data.data);
    }
  }

  async function getSelectListVendedor() {
    let vendedores = await PedidoService.getSelectListVendedor();

    if (vendedores.data) {
      setVendedores(vendedores.data.data);
    }
  }

  async function getSelectListProdutos(representadaId) {
    if (!representadaId && representadaId == null) return;

    window.showLoader();
    var ids = [representadaId];
    let produtosResponse = await PedidoService.listProdutosPorRepresentadasAsync(ids);

    window.hideLoader();
    let selectList = [];

    if (produtosResponse.data && produtosResponse.data.data.length > 0) {
      selectList = produtosResponse.data.data.map((x) => ({
        label: x.nome.toString(),
        value: x.produtoId.toString()
      }));
    }
    setProdutos(selectList);
  }

  async function getPedidosNaoFaturados() {
    window.showLoader();

    let response = await PedidoService.GetPedidosNaoFaturados(filter);

    if (response?.data?.data != null) {
      setPedidos(response?.data?.data);
    }
    window.hideLoader();
  }

  async function descartarValor(result) {
    if (result === 'yes') {
      window.showLoader();
      let result = await PedidoFaturamentoService.descartarValorAsync(
        selectedDescartar.pedidoRepresentadaId
      );
      getPedidosNaoFaturados();
    }
    setShowModalDescartar(false);
    setSelectedDescartar(null);
  }

  return (
    <Layout>
      <PageTitleCard title="Descarte Não Faturados" />

      {/* Filter ------------------------------------------------------------------------------ */}
      <div className="row filter-bar2">
        {/* Codigo  --------------------------------------------------------------------------- */}
        <div className="col-xl-3 mb-3">
          <label>Pedido</label>
          <input
            type="text"
            className="form-control"
            value={filter.codigo}
            onChange={(ev) => {
              setFilter({
                ...filter,
                codigo: ev.target.value
              });
            }}
          />
        </div>

        {/* Vendedor ---------------------------------------------------------------------- */}
        <div className="col-xl-3 mb-3">
          <label>Vendedor</label>
          <Select
            isClearable
            clearValue={() => {
              setFilter({
                ...filter,
                vendedorId: null
              });
            }}
            styles={customControlStyles}
            placeholder="Selecione..."
            options={vendedores}
            value={vendedores?.find((x) => x.value === filter.vendedorId)}
            onChange={(selectedValue) => {
              setFilter({
                ...filter,
                vendedorId: selectedValue?.value
              });
            }}
          />
        </div>

        {/* Tipo ---------------------------------------------------------------------- */}
        <div className="col-xl-3 mb-3" disabled>
          <label>Tipo</label>
          <SelectMulti
            isClearable
            clearValue={() => {
              setFilter({ ...filter, pedidoTipos: [] });
              setTiposSelecionados([]);
            }}
            styles={customControlStyles}
            placeholder="Selecione..."
            options={pedidoTipos}
            // value={pedidoTipos.filter((p) => filter.pedidoTipos.includes(p.value))}
            value={tiposSelecionados}
            onChange={(options) => {
              setFilter({ ...filter, pedidoTipos: options.map((x) => x.value) });
              setTiposSelecionados(options);
            }}
          />
        </div>

        {/* Representada ---------------------------------------------------------------------- */}
        <div className="col-xl-3 mb-3" disabled>
          <label>Representada</label>
          <Select
            isClearable
            clearValue={() => {
              // setRepresentadaSelecionada('');
              setFilter({
                ...filter,
                representadaId: null
              });
            }}
            styles={customControlStyles}
            placeholder="Selecione..."
            options={representadas}
            value={representadas?.find((x) => x.value === filter.representadaId)}
            onChange={(selectedValue) => {
              setFilter({
                ...filter,
                representadaId: selectedValue?.value
              });
              //setRepresentadaSelecionada(selectedValue?.value);
              //getSelectListProdutos(selectedValue?.value);
            }}
          />
        </div>

        {/* Produtos ------------------------------------------------------------------------------ */}
        {/* <div className="col-xl-6 mb-6" disabled>
          <label>Produtos Por Representada</label>
          &nbsp;&nbsp;
          <span style={{ fontSize: '8px' }}>
            *Selecione uma representada para carregar os produtos
          </span>
          <SelectMulti
            isClearable
            clearValue={() => {
              setFilter({ ...filter, produtosIds: [] });
            }}
            placeholder="Produtos da Loja"
            styles={customControlStyles}
            options={produtos}
            value={
              //produtos.filter((p) => filter.produtosIds.includes(p.value))
              filter.produtos
            }
            onChange={(options) => {
              setFilter({
                ...filter,
                produtos: options,
                produtosIds: options.map((p) => p.value)
              });
            }}
          />
        </div> */}

        {/* Rede ------------------------------------------------------------------------------ */}
        <div className="col-xl-3 mb-3" disabled>
          <label>Rede</label>
          <Select
            isClearable
            clearValue={() => {
              setRedeSelecionada({});
            }}
            styles={customControlStyles}
            placeholder="Selecione..."
            options={redes}
            value={redes?.find((x) => x.value === filter.redeId)}
            onChange={(
              selectedValue //setRedeSelecionada(selectedValue?.value)
            ) =>
              setFilter({
                ...filter,
                redeId: selectedValue?.value
              })
            }
          />
        </div>

        {/* Loja ------------------------------------------------------------------------------ */}
        <div className="col-xl-3 mb-3">
          <label>CNPJ da Loja</label>
          <input
            type="text"
            className="form-control"
            value={filter.lojaCnpj}
            onChange={(ev) => {
              // setLojaCnpj(ev.target.value);
              setFilter({
                ...filter,
                lojaCnpj: ev.target.value
              });
            }}
          />
        </div>

        <div className="col-lg-3 mb-3">
          <label>Data Inicial </label>
          <DatePickerCustom
            name="dataInicio"
            selected={filter.dataInicio}
            onChange={(value) => {
              setFilter({
                ...filter,
                dataInicio: value
              });
            }}
          />
        </div>

        <div className="col-lg-3 mb-3">
          <label>Data Final</label>
          <DatePickerCustom
            name="dataFim"
            selected={filter.dataFim}
            onChange={(value) => {
              setFilter({
                ...filter,
                dataFim: value
              });
            }}
          />
        </div>

        {/* <div className="col-xl-3 mb-3" disabled>
          <label>Status</label>
          <SelectMulti
            isClearable
            clearValue={() => {
              // setStatus([]);
              setFilter({
                ...filter,
                status: []
              });
            }}
            placeholder="Selecione..."
            options={statusSelectList}
            value={
              //statusSelectList.filter((x) => filter.statusPedidos.includes(x.value))
              filter.statusPedidos
            }
            onChange={(options) => {
              // setStatus(options);
              setFilter({
                ...filter,
                status: options,
                statusPedidosIds: options.map((x) => x.value)
              });
            }}
          />
        </div> */}

        {/* Botão Filtrar --------------------------------------------------------------------- */}
        <div className="col-lg-3 mb-3 d-flex align-items-center">
          <button
            type="button"
            className="btn btn-secondary btn-sm btn-action"
            onClick={() => {
              getPedidosNaoFaturados();
            }}
          >
            <FontAwesomeIcon icon={faFilter} /> Filtrar
          </button>
        </div>
      </div>

      {/* Lista Representadas ----------------------------------------------------------------- */}
      <div className="table-responsive mt-4">
        <table className="table table-cadastro">
          <thead>
            <tr>
              <th>Pedido</th>
              <th>Data</th>
              <th>Dias em Aberto</th>
              <th>Rede</th>
              <th>Loja</th>
              <th>Representada</th>
              <th>Status</th>
              <th>Valor Não Faturado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {(pedidos?.data || []).map((item, index) => (
              <tr key={index}>
                <td>
                  {item.codigoPedidoLoja ? item.codigoPedidoLoja : item.codigoPedidoRepresentada}
                </td>
                <td>{lib.getStringFromDate(item.data)}</td>
                <td className="text-center">{item.diasEmAberto}</td>
                <td>{item.redeNome}</td>
                <td>
                  {item.lojaNomeFantasia ?? item.lojaRazaoSocial}
                  <span className="loja-subtitulo">{item.lojaCnpj}</span>
                </td>
                <td>{item.representadaNomeFantasia}</td>
                <td>{item.status}</td>
                <td>{lib.formatToCurrencyText(item.valorNaoFaturado)}</td>
                <td>
                  <div className="action-btns d-flex">
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      title="Ver Pedido"
                      onClick={() => {
                        setSelected(item);
                        setShowModalResumo(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>

                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      title="Descartar Faturamento"
                      onClick={() => {
                        setSelected(item);
                        setSelectedDescartar(item);
                        setShowModalDescartar(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </button>

                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      title="Cancelar Pedido"
                      onClick={() => {
                        setSelected(item);
                        setShowModalCancelar(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Paginacao --------------------------------------------------------------------------- */}
      <TablePagination
        pageData={pedidos}
        onChangePage={(page) => {
          setFilter({ ...filter, pageNumber: page });
        }}
      />

      <ModalResumoPedido
        model={selected}
        showModal={showModalResumo}
        setShowModal={setShowModalResumo}
      />

      <ModalConfirmacao
        showModal={showModalDescartar}
        setShowModal={setShowModalDescartar}
        onClose={descartarValor}
      >
        {selectedDescartar && (
          <>
            Tem certeza que deseja descartar o valor{' '}
            {
              <NumberFormat
                value={selectedDescartar.valorNaoFaturado}
                displayType={'text'}
                thousandSeparator={'.'}
                decimalSeparator={','}
                prefix={'R$ '}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            }{' '}
            da representada {selectedDescartar.representadaNomeFantasia}?
          </>
        )}
      </ModalConfirmacao>

      <ModalCancelarPedido
        model={selected}
        showModal={showModalCancelar}
        setShowModal={setShowModalCancelar}
      />
    </Layout>
  );
}
